import { VehicleAttributes } from '@/types'
import { CreateVehicleMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { useNavigate } from 'react-router'
import { ErrorMessage, Field, Label } from '../base/fieldset'
import { Selector as ManufacturerSelector } from './manufacturer/selector'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const navigate = useNavigate()

  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    mutationData,
    attributes,
    setAttributes,
    fieldErrors
  } = useForm<CreateVehicleMutation, VehicleAttributes, never, never>({
    defaultValues: {
      cabSize: 0,
      registration: '',
      warehouseId: '',
      rateCents: 0,
      costCents: 0,
      mileageCents: 0,
      model: '',
      manufacturer: '',
      width: 0,
      height: 0,
      length: 0,
      payload: 0,
      notes: ''

    },
    mutation: CreateMutation,
    resultKey: 'createVehicle',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  useEffect(() => {
    if (!mutationData?.createVehicle?.vehicle?.id) return

    navigate(`/vehicles/${mutationData?.createVehicle?.vehicle?.id}`)
  }, [mutationData, navigate])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      <div className="grid grid-cols-4 gap-6">
        <Field>
          <Label>Manufacturer</Label>
          <ManufacturerSelector
            invalid={!!fieldErrors?.manufacturer}
            value={attributes.manufacturer}
            onChange={value => {
              setAttributes({ ...attributes, manufacturer: value?.id || '' })
            }}
          />
          { fieldErrors?.manufacturer && <ErrorMessage>{ fieldErrors?.manufacturer }</ErrorMessage> }
        </Field>
        { formBuilder.buildField({ name: 'Model', field: 'model', type: 'text' }) }
        { formBuilder.buildField({ name: 'Registration', field: 'registration', type: 'text' }) }
        { formBuilder.buildField({ name: 'Warehouse', field: 'warehouseId', type: 'warehouse' }) }
      </div>
      <div className="grid grid-cols-4 gap-6">
        { formBuilder.buildField({ name: 'Cab size', field: 'cabSize', type: 'integer' }) }
        { formBuilder.buildField({ name: 'Cost', field: 'costCents', type: 'currency' }) }
        { formBuilder.buildField({ name: 'Hire rate', field: 'rateCents', type: 'currency' }) }
        { formBuilder.buildField({ name: 'Mileage rate', field: 'mileageCents', type: 'currency' }) }
      </div>
      <div className="grid grid-cols-4 gap-6">
        { formBuilder.buildField({ name: 'Payload', field: 'payload', type: 'weight' }) }
        { formBuilder.buildField({ name: 'Width', field: 'width', type: 'dimension' }) }
        { formBuilder.buildField({ name: 'Height', field: 'height', type: 'dimension' }) }
        { formBuilder.buildField({ name: 'Length', field: 'length', type: 'dimension' }) }
      </div>
      { formBuilder.buildField({ name: 'Notes', field: 'notes', type: 'textarea' }) }

      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
